import instagramIcon from "../assets/images/insta.svg";
import youtubeIcon from "../assets/images/youtube.svg";
import blogIcon from "../assets/images/blog.svg";

const socialLinks = [
	{
		name: "Blog",
		href: "https://blog.naver.com/anatoleenglish",
		icon: (
			<img src={blogIcon} alt="Blog" className="w-[35px] h-auto" />
		),
	},
	{
		name: "Instagram",
		href: "https://www.instagram.com/anatole_school/",
		icon: (
			<img src={instagramIcon} alt="Instagram" className="w-[35px] h-auto" />
		),
	},
	{
		name: "YouTube",
		href: "https://youtube.com/@anatoleschool",
		icon: (
			<img src={youtubeIcon} alt="YouTube" className="w-[35px] h-auto" />
		),
	},
];

const SocialLinks = ({ className = "" }) => {
	return (
		<div className={`flex items-center space-x-4 ${className}`}>
			{socialLinks.map((item) => (
				<a
					key={item.name}
					href={item.href}
					target="_blank"
					rel="noopener noreferrer"
					className="hover:text-gray-200 transition-colors"
					aria-label={item.name}
				>
					{item.icon}
				</a>
			))}
		</div>
	);
};

export default SocialLinks;
